import { useState } from "react";
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import styles from "./office-tour.module.css";
import { OptimizedImage } from "~/components/OptimizedImage";

const imageColumns = [
  {
    id: "left",
    images: [
      {
        src: "/office-live-1.jpg",
        alt: "Modern orthodontic waiting area at Miami Orthodontic Specialists featuring patients relaxing with magazines, children using tablets, and a vibrant floral artwork on the wall, emphasizing a welcoming environment for braces and Invisalign treatments.",
        height: 281,
        width: 421,
      },
      {
        src: "/office-live-2.jpg",
        alt: "Gumball machines filled with colorful toys in a Miami orthodontic office, emphasizing a welcoming atmosphere for families and children seeking braces and Invisalign treatments.",
        height: 631,
        width: 421,
      },
      {
        src: "/office-live-3.jpg",
        alt: "Modern orthodontic office interior featuring private treatment rooms, green accents, and a welcoming atmosphere, emphasizing comfort for patients at Miami Orthodontic Specialists.",
        height: 421,
        width: 421,
      },
      {
        src: "/office-live-4.jpg",
        alt: "Modern orthodontic waiting area at Miami Orthodontic Specialists featuring clear chairs, a view of greenery, and a television, emphasizing a comfortable environment for braces and Invisalign patients.",
        height: 561,
        width: 421,
      },
      {
        src: "/office-live-5.jpg",
        alt: "Modern orthodontic treatment room at Miami Braces, featuring privacy dividers, sleek cabinetry, and a welcoming atmosphere for braces and Invisalign patients.",
        height: 281,
        width: 421,
      },
    ],
  },
  {
    id: "right",
    images: [
      {
        src: "/office-live-6.jpg",
        alt: "Smiling receptionist assisting a patient at Miami Orthodontic Specialists, featuring a modern office design with orchids and a welcoming atmosphere, highlighting patient comfort in orthodontic care.",
        height: 281,
        width: 421,
      },
      {
        src: "/miami-ortho-3.jpg",
        alt: "Modern orthodontic treatment room at Miami Orthodontic Specialists featuring private chairs, digital imaging screens, and a bright, welcoming atmosphere.",
        height: 281,
        width: 421,
      },
      {
        src: "/office-live-8.jpg",
        alt: "Modern orthodontic treatment room at Miami Orthodontic Specialists, featuring privacy dividers, green dental chairs, and a computer workstation, emphasizing a comfortable environment for braces and Invisalign adjustments.",
        height: 421,
        width: 421,
      },
      {
        src: "/office-live-9.jpg",
        alt: "Modern orthodontic office waiting area featuring a coffee station, water cooler, and seating, designed for patient comfort at Miami Orthodontic Specialists.",
        height: 561,
        width: 421,
      },
      {
        src: "/office-live-10.jpg",
        alt: "Group of children waiting in a Miami orthodontics office, engaging with devices and a soccer ball, showcasing a welcoming atmosphere for braces and Invisalign treatments.",
        height: 281,
        width: 421,
      },
      {
        src: "/office-live-11.jpg",
        alt: "Orthodontist in Miami explaining treatment options to a patient in a modern, private care room at Miami Braces, emphasizing a comfortable and welcoming environment for braces and Invisalign consultations.",
        height: 281,
        width: 421,
      },
    ],
  },
];

const images = imageColumns.flatMap((column) => column.images);
const slides = images.map((image) => ({
  src: image.src,
  alt: image.alt,
  width: image.width,
  height: image.height,
}));

export function ImageGallery() {
  const [index, setIndex] = useState(-1);

  return (
    <>
      <div className={styles.galleryGrid}>
        {imageColumns.map((column) => (
          <div className={styles.galleryColumn} key={column.id}>
            {column.images.map((image) => (
              <button
                type="button"
                key={image.src}
                className={styles.galleryButton}
                onClick={() => setIndex(images.indexOf(image))}
                aria-label={`Open image gallery: ${image.alt}`}
              >
                <OptimizedImage
                  src={image.src}
                  alt={image.alt}
                  width={image.width}
                  height={image.height}
                  className={styles.galleryImage}
                  loading="lazy"
                />
              </button>
            ))}
          </div>
        ))}
      </div>
      <Lightbox
        open={index >= 0}
        index={index}
        close={() => setIndex(-1)}
        slides={slides}
        styles={{
          container: {
            backgroundColor: "rgba(0, 0, 0, 0.82)",
          },
        }}
      />
    </>
  );
}
